export class ProjectSettings
{
  constructor(
    public shouldRequestPurchaseOrder: boolean|null,
    public shouldSendManDaySheet: boolean|null,
    public shouldUseGAccount: boolean|null,
    public requiresProjectNumber: boolean|null,
  ) {
  }
  static fromJson(json: any): ProjectSettings {
    return new ProjectSettings(
      json['should_request_purchase_order'] ?? null,
      json['should_send_man_day_sheet'] ?? null,
      json['should_use_g_account'] ?? null,
      json['requires_project_number'] ?? null,
  )
  }
}

export const projectSettingsText = {
  shouldRequestPurchaseOrder: {
    title: 'Bon Aanvragen',
    description: 'P.O. aanvragen bij bestellingen',
  },
  shouldSendManDaySheet: {
    title: 'Mandagen Staat Meesturen',
    description: 'Overzicht van gewerkte uren t.b.v. administratie',
  },
  shouldUseGAccount: {
    title: 'G. Rekening',
    description: 'Gebruik van rekening voor loonbelasting',
  },
  requiresProjectNumber: {
    title: 'Verplicht Projectnummer',
    description: 'Gebruik projectnummer als referentie',
  },
}